import reduceReducers from 'reduce-reducers';
import { combineReducers } from 'redux';

const entityById =
  (name) =>
  (stateIn = {}, action) => {
    const isSource = (obj) =>
      obj &&
      Object.prototype.hasOwnProperty.call(obj, 'entities') &&
      Object.prototype.hasOwnProperty.call(obj.entities, name);

    const source = isSource(action.meta)
      ? action.meta
      : isSource(action.payload)
      ? action.payload
      : null;

    let state = stateIn;
    if (source) {
      state = { ...stateIn, ...source.entities[name] };
      if (source.resultFor === name) {
        state = { ...stateIn, __ALL__: source.result };
      }
    }

    return state;
  };

const parts = (stateIn = {}, action) => {
  const state = entityById('parts')(stateIn, action);

  switch (action.type) {
    default:
      return state;
  }
};

const entityReducer = combineReducers({
  parts,
  partModels: entityById('partModels'),
  materials: entityById('materials'),
  finishes: entityById('finishes'),
  manufacturers: entityById('manufacturers'),
  availableManufacturers: entityById('availableManufacturers'),
  machines: entityById('machines'),
  availableMachines: entityById('availableMachines'),
  availableMaterials: entityById('availableMaterials'),
  colors: entityById('colors'),
  orders: entityById('orders'),
  quotes: entityById('quotes'),
  quoteItems: entityById('quoteItems'),
  quoteItemAddOns: entityById('quoteItemAddOns'),
  quoteItemAddOnCells: entityById('quoteItemAddOnCells'),
  quoteItemProfitItems: entityById('quoteItemProfitItems'),
  quoteItemProfitItemCells: entityById('quoteItemProfitItemCells'),
  quoteItemDiscounts: entityById('quoteItemDiscounts'),
  quoteItemDiscountCells: entityById('quoteItemDiscountCells'),
  quoteItemBriefComponents: entityById('quoteItemBriefComponents'),
  quoteItemComponents: entityById('quoteItemComponents'),
  quoteItemCells: entityById('quoteItemCells'),
  quoteItemExpedites: entityById('quoteItemExpedites'),
  quoteItemOperations: entityById('quoteItemOperations'),
  quoteItemQuantities: entityById('quoteItemQuantities'),
  opDefs: entityById('opDefs'), //TODO: MAKE COMPATIBLE WITH IGORS CHANGES
});

const reducer = reduceReducers(entityReducer);

export default reducer;
